import * as z from 'zod';

export const FormatSchema = z.object({
  ext: z.string().optional(),
  url: z.string().optional(),
  hash: z.string().optional(),
  mime: z.string().optional(),
  name: z.string().optional(),
  path: z.string().nullable().optional(),
  size: z.number().optional(),
  width: z.number().optional(),
  height: z.number().optional(),
});

export const MediaItemSchema = z.object({
  id: z.number(),

  documentId: z.string(),
  name: z.string(),
  hash: z.string(),
  ext: z.string(),
  mime: z.string(),
  url: z.string(),
  provider: z.string(),

  size: z.number(),
  width: z.number().nullable(),
  height: z.number().nullable(),

  alternativeText: z.string().nullable(),
  caption: z.string().nullable(),
  previewUrl: z.string().nullable(),
  provider_metadata: z.unknown().nullable(),

  createdAt: z.string(),
  updatedAt: z.string(),
  publishedAt: z.string(),

  formats: z
    .object({
      large: FormatSchema.optional(),
      small: FormatSchema.optional(),
      medium: FormatSchema.optional(),
      thumbnail: FormatSchema.optional(),
    })
    .partial()
    .nullable(),
});

export type MediaItem = z.infer<typeof MediaItemSchema>;
